import { render, staticRenderFns } from "./FAQUseCoupon.vue?vue&type=template&id=465af366&scoped=true"
import script from "./FAQUseCoupon.vue?vue&type=script&lang=js"
export * from "./FAQUseCoupon.vue?vue&type=script&lang=js"
import style0 from "./FAQUseCoupon.vue?vue&type=style&index=0&id=465af366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465af366",
  null
  
)

export default component.exports